module.exports = __webpack_public_path__ + "static/media/middle-section.b87b1dff.png";